module.exports = __webpack_public_path__ + "static/img/3-info-b3.3b58855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b3.jpg
// module id = //XY
// module chunks = 0